export default __webpack_public_path__ + "static/media/siemens.40453191.svg";